import React, { useCallback, useRef, useState } from 'react'
import './style.css'
import { DotsSixVertical, Eye } from '@phosphor-icons/react'

export default function Layer({ element, datas, editSlide, closeElement, select, addSelects }) {
    const [dragId, setDragId] = useState(null)
    const [open, setOpen] = useState(false)
    const [clickedPosition, setClickedPosition] = useState({ x: -1, y: -1 })
    const [click, setClick] = useState({ x: 0, y: 0 })
    const [delta, setDelta] = useState({ x: 0, y: 0 })

    const outerDiv = useRef(null);

    const onMouseDown = (e, id) => {
        e.stopPropagation()
        setClickedPosition({ x: e.clientX, y: e.clientY })
        const outerRect = outerDiv?.current?.getBoundingClientRect();
        const clickX = e.clientX - outerRect?.left;
        const clickY = e.clientY - outerRect?.top;
        setClick({ x: clickX - 17.5, y: clickY - 17.5 })
        setDelta({ x: clickX - 17.5, y: clickY - 17.5 })
        if (clickX) {
            setDragId(id)
        }
    }

    const onMouseUp = (e) => {
        e.stopPropagation()
        if (dragId) {
            setDragId(null)
            setClickedPosition({ x: -1, y: -1 })
            setDelta({ x: 0, y: 0 })
        }
    }

    const onMouseMove = useCallback((event) => {
        if (clickedPosition.x >= 0 && clickedPosition.y >= 0) {
            const deltaX = (event.clientX - clickedPosition?.x)
            const deltaY = (event.clientY - clickedPosition?.y)
            setDelta({
                x: click.x + deltaX,
                y: click.y + deltaY
            })
        }
    }, [clickedPosition])

    const moveItem = (toIndex) => {
        const fromIndex = datas?.findIndex((e) => e?.id === dragId?.id)
        if (fromIndex < 0 || fromIndex >= datas?.length || toIndex < 0 || toIndex >= datas?.length) {
            console.error('Invalid indices');
            return;
        }
        const newArray = [...datas];
        const [movedItem] = newArray.splice(fromIndex, 1);
        newArray.splice(toIndex, 0, movedItem);
        editSlide("elements", newArray)
    };

    const onMouseEnter = (e, id, index) => {
        if (dragId) {
            moveItem(index)
        }
    }

    return (
        <div ref={outerDiv} tabIndex={0}>
            <div className='Layer' onClick={() => setOpen(!open)}>{open ? closeElement : element}
                <div onMouseMove={(e) => onMouseMove(e)} onMouseUp={onMouseUp} onMouseLeave={onMouseUp} style={{ cursor: dragId ? 'grabbing' : null }} onClick={(e) => e.stopPropagation()} className={open ? 'Layer_Con Layer_Con_Open' : 'Layer_Con'}>
                    {open ?
                        <>
                            {datas?.length === 0 ?
                                <div className='Layer_Empty'>
                                    <p>No layers found</p>
                                </div>
                                :
                                datas?.map((item, index) => {
                                    if (item?.id === dragId?.id) {
                                        return (
                                            <div key={index} className='Layer_Empty_Item' />
                                        )
                                    }
                                    return (
                                        <div key={index} className={select === item?.id? 'Layer_Item Layer_Item_Select' : 'Layer_Item'} onMouseEnter={(e) => onMouseEnter(e, item?.id, index)} onClick={()=>addSelects(item?.id)}>
                                            <DotsSixVertical onMouseDown={(e) => datas?.length > 1 ? onMouseDown(e, item) : null} className={datas?.length > 1 ? 'Layer_Icon' : 'Layer_Icon Layer_Icon_NotAllowed'} />
                                            <p>{item?.type}</p>
                                            <div className='FlexCon' />
                                            <Eye className='Layer_Icon1' />
                                        </div>
                                    )
                                })}
                        </>
                        : null}
                </div>
                {dragId ?
                    <div style={{ top: `${delta.y}px`, left: `${delta.x}px` }} className='Layer_Item Layer_Absolute'>
                        <DotsSixVertical className='Layer_Icon' />
                        <p>{dragId?.type}</p>
                        <div className='FlexCon' />
                        <Eye className='Layer_Icon1' />
                    </div>
                    : null}
            </div>
        </div>
    )
}
